'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPE = exports.TYPE = ['@type'];
var FALLBACK = exports.FALLBACK = ['fallback'];
var USER_IDS = exports.USER_IDS = ['userIds'];
var TEAM_IDS = exports.TEAM_IDS = ['teamIds'];
var CUSTOM_CHAT_NAME = exports.CUSTOM_CHAT_NAME = ['customChatName'];
var COMPANY_LOGO = exports.COMPANY_LOGO = ['companyLogoUrl'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/operators/keyPaths.js
// module id = 117
// module chunks = 2 3